import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import {useFrame} from '@react-three/fiber';
import {a} from '@react-spring/three' //for animations
import TWEEN from '@tweenjs/tween.js'
import houseScene from '../assets/3d/draco_house_comp2.glb';
const House=({controls,setCurrentStage,...props})=> {
  const { nodes, materials } = useGLTF(houseScene, true); // true is passed to useDraco component to enable draco loader
  const houseRef=useRef();

  useFrame(()=>{

  })

  return (
    <a.group ref={houseRef} {...props} >
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2.geometry}
        material={materials.Summer_Evening}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2001.geometry}
        material={materials.Concrete_and_Wood}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2002.geometry}
        material={materials.House_With_A_Yellow_Seat}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2003.geometry}
        material={materials.Sofa_Midas_Costuras}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2004.geometry}
        material={materials.Concrete_and_Wood_02}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2005.geometry}
        material={materials.material}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2017.geometry}
        material={materials.Pale_lancelot_oak_PBR}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2020.geometry}
        material={materials.Porphyritic_Granite_stack_dvas52}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2021.geometry}
        material={materials.Fluted_Granite__Stack}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2022.geometry}
        material={materials['40_black_portoro_gold_pbr_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2023.geometry}
        material={materials['Seamless_stucco_plaster_-black']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2024.geometry}
        material={materials.sehpa_mermer__marble}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2025.geometry}
        material={materials.Charred_Timber}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2027.geometry}
        material={materials.Translucent_Glass_Gray}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2046.geometry}
        material={materials.Plain_Natural_Blackout_Sheer}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2057.geometry}
        material={materials.material_12}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2063.geometry}
        material={materials.material_77}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2064.geometry}
        material={materials['16_Terrazzo_surface_PBR_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2065.geometry}
        material={materials.Color_008}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2072.geometry}
        material={materials.Vegetation_Bark_Maple2}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2073.geometry}
        material={materials.material_6}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2074.geometry}
        material={materials.material_5}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2075.geometry}
        material={materials.Polished_Concrete_Old}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2076.geometry}
        material={materials.Weathered_Timber_Staggered}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2077.geometry}
        material={materials['148_dark_parquet_flooring_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2078.geometry}
        material={materials.Granite_Stack_431}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2079.geometry}
        material={materials.Oak_2}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2081.geometry}
        material={materials.shadow}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2082.geometry}
        material={materials.junip1_4}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2083.geometry}
        material={materials['24_pool_water_texture_seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2084.geometry}
        material={materials.Color_F19}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2102.geometry}
        material={materials.Grass}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2103.geometry}
        material={materials['Texture_2.jpeg']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2104.geometry}
        material={materials.Water_Deep}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2106.geometry}
        material={materials['23_brushed_dark_steel_metal']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2108.geometry}
        material={materials['31_brushed_copper_metal_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2114.geometry}
        material={materials.brushed_aluminium}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2115.geometry}
        material={materials.PDM_Leather_BandB_AC_Lounge_2}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2121.geometry}
        material={materials['26_old_dirty_copper_metal_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2123.geometry}
        material={materials.Color_M07}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2135.geometry}
        material={materials['23_brushed_dark_steel_metal_7']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2136.geometry}
        material={materials['vase-ode-to-baydo']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2137.geometry}
        material={materials.material_47}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2142.geometry}
        material={materials.Plain_Natural_Blackout}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2143.geometry}
        material={materials.Mirror_01}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2144.geometry}
        material={materials.BLACK_TEXTURE_CERAMIC_SHEEN}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2145.geometry}
        material={materials.E27_3D_Emissive_White1}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2147.geometry}
        material={materials['Camel___Ivory_Rug__Labyrinth__-_Jonathan_Adler']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2148.geometry}
        material={materials.Dense_Rattan}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2152.geometry}
        material={materials['Smart-TV-Menu']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2154.geometry}
        material={materials.Slate_staggered_yovds6}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2155.geometry}
        material={materials.Stacy_Shirt}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2156.geometry}
        material={materials.FREIXO_PAINEL}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2159.geometry}
        material={materials['Mid_Century_-_Fallingwater-final']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2160.geometry}
        material={materials['Mid_Century_-Paraty-House-Brazil']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2161.geometry}
        material={materials.blad1}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2162.geometry}
        material={materials.zand1}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2163.geometry}
        material={materials.blad2}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2164.geometry}
        material={materials.Affresco_Grey}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2165.geometry}
        material={materials['Frowers_Tropical_-_Blk_Wht']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2166.geometry}
        material={materials.material_15}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2167.geometry}
        material={materials.Color_D02}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2169.geometry}
        material={materials.Sofa_Midas_Estofado_Branco_Leather}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2170.geometry}
        material={materials.Sofa_Midas_Ps}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2171.geometry}
        material={materials.Sofa_Midas_Estofado_Leather}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2172.geometry}
        material={materials.Corduroy}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2173.geometry}
        material={materials.Geometric_Natural_Jacquard}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2174.geometry}
        material={materials.AAAA}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2177.geometry}
        material={materials.White_Painted_Stone_Tall_Green}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2180.geometry}
        material={materials.material_15_19}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2181.geometry}
        material={materials.material_50}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2182.geometry}
        material={materials['green-leather_texture-seamless']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2205.geometry}
        material={materials.CAMALEONDA_19___Default}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2207.geometry}
        material={materials.Persian_Rug_blue}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2208.geometry}
        material={materials['Andy_Burgess_-_01']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2209.geometry}
        material={materials['Andy_Burgess_-_02']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2210.geometry}
        material={materials.auto}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material2211.geometry}
        material={materials.WALL_CLOCK}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3.geometry}
        material={materials['Seamless_stucco_plaster_-black_0']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3001.geometry}
        material={materials.Fluted_Granite__Stack_1}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3002.geometry}
        material={materials.material_3_3}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3004.geometry}
        material={materials.material_3}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3005.geometry}
        material={materials['Wood-cherry']}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3006.geometry}
        material={materials.Fan_Palm_leaf}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3008.geometry}
        material={materials.material_5_9}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3013.geometry}
        material={materials.Pale_lancelot_oak_PBR_12}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material3015.geometry}
        material={materials.material_18}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Material4.geometry}
        material={materials.Oak_20}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.021}
      />
    </a.group>
  );
}


export default House;